import { HotjarService } from './../auth-module/services/hotjarService';
import { FacebookService } from './../lib/services/facebookService';
import { EmploymentService } from './services/employments';

import { HttpLoaderFactory } from '../app.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { layoutReducer } from './reducers/layout';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { ProgressInterceptor } from './interceptors/progress.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { Store, StoreModule } from '@ngrx/store';
import { processesReducer } from '../jobs-module/edit-job-tpl-process/reducers/process.reducers';
import { EffectsModule } from '@ngrx/effects';
import { ProcessEffects } from '../jobs-module/edit-job-tpl-process/effects/process.effects';
import { paymentStatusReducer } from './reducers/paymentStatus';
import { PaymentStatusEffects } from './effects/paymentStatus';
import { RequestInterceptor } from './interceptors/request.interceptor';
import { employmentReducer } from './reducers/employment';
import { EmploymentsEffects } from './effects/employments';
import { authReducer } from './reducers/auth';
import { AuthEffects } from './effects/auth';
import { NotificationsReducer } from './reducers/notifications';
import { NotificationsEffects } from './effects/notifications';

export const COMPONENTS = [];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    // SharedModule,
    TranslateModule,
    // PipesModule,

    StoreModule.forFeature('paymentStatus', paymentStatusReducer),
    EffectsModule.forFeature([PaymentStatusEffects]),
    StoreModule.forFeature('employments', employmentReducer),
    EffectsModule.forFeature([EmploymentsEffects]),
    StoreModule.forFeature('currentUser', authReducer),
    EffectsModule.forFeature([AuthEffects]),
    StoreModule.forFeature('notifications', NotificationsReducer),
    EffectsModule.forFeature([NotificationsEffects]),
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class CoreModule {
  static forRoot() {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ProgressInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: RequestInterceptor,
          multi: true,
        },
        EmploymentService,
        FacebookService,
        HotjarService,
      ],
    };
  }
}
